import retrieveDataFromAPI from "./retrieveDataFromAPI";

const GetAllGrades = async () => {
  return retrieveDataFromAPI(`/grades`);
};
export default GetAllGrades;
